<template>
  <div :id="`node.event.${node.data.id}`" class="event">
    <LKRoadmapsFeedCardEventUp
      :node="node"
      :statusless="statusless"
      :readonly="readonly || readonlyAdresat"
      v-on="$listeners || {}"
    />

    <div class="event__down">
      <LKRoadmapsFeedToggleLine
        :active="node.isActive"
        :loading="node.loading"
        label="Показать файлы"
        class="mod--directions"
        @click.native="onLoadChildren"
      />

      <LKToggleContainer
        :active="node.isActive"
        class="files__wrapper"
      >
        <LKRoadmapsFeedCardFiles
          :node="node"
          :load-children="loadChildren"
          :readonly="readonly"
          v-on="$listeners || {}"
        />
      </LKToggleContainer>
    </div>
  </div>
</template>

<script>
import { isBeforeToday } from '@/helpers/dateFormatter'
import { RoadmapEventStatuses } from '@/typings/api/RoadmapEvent'
import { loadChildrenMixin } from '../mixins'

import LKToggleContainer from '@/components/lk/LKToggleContainer.vue'
import LKRoadmapsFeedToggleLine from '../ui/LKRoadmapsFeedToggleLine.vue'
import LKRoadmapsFeedCardFiles from '../CardFiles/LKRoadmapsFeedCardFiles.vue'
import LKRoadmapsFeedCardEventUp from './LKRoadmapsFeedCardEventUp.vue'


export default {
  name: 'LKRoadmapsFeedCardEvent',
  inject: [
    'isAdresat',
    'isCurator',
    'isCoordinator',
  ],
  components: {
    LKToggleContainer,
    LKRoadmapsFeedToggleLine,
    LKRoadmapsFeedCardFiles,
    LKRoadmapsFeedCardEventUp,
  },
  mixins: [
    loadChildrenMixin,
  ],
  inheritAttrs: false,
  props: {
    readonly: Boolean,
  },
  computed: {
    readonlyAdresat() {
      const { data } = this.node

      return (
        this.isAdresat
        && data.status === RoadmapEventStatuses.confirmed
      )
    },
    statusless() {
      const { data } = this.node

      return (
        this.isAdresat
        && isBeforeToday(data.end_at)
        && data.status === RoadmapEventStatuses.expired
      )
    },
  },
}
</script>
